import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicStoreKarmaRewards: Story = {
  id: 'magic-store-karma-rewards',
  type: 'CLASSIC',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store Karma Rewards',
  index: 0,
  content: {
    type: ACTION_TYPES.GO_TO_AUTH,
    bannerUrl: 'stories/2/main_banner.jpg',
    bannerMobileUrl: 'stories/2/main_banner_mobile.jpg',
    buttonText: 'Go to Karma',
    internalRoute: '/profile/karma',
    title: 'Navigate Your Magic Karma Dashboard',
    description:
      'Your Magic Karma Dashboard in Magic Store keeps you updated on your Karma progress. From the Leaderboard, Daily Pool, Total Reward, to My Daily Ratio, each feature provides a comprehensive view of your contribution and earnings. And the best part? Claiming your rewards is as simple as a click!',
    storyBlocks: [
      {
        bannerUrl: 'stories/2/story_banner_url_1.jpg',
        title: 'Magic Karma: Contribute and Earn Rewards on Magic Store',
        description:
          "Magic Karma is more than a score, it's a reward system on Magic Store that encourages and values your participation and positive actions within the platform.",
      },
      {
        bannerUrl: 'stories/2/story_banner_url_2.jpg',
        title: 'Rewarding Positive Actions',
        description:
          "Every action you make within the Magic Store, whether claiming a hot offer, voting for an app, or verifying your email, contributes to your Magic Karma score. You're rewarded not just for your purchases, but for every positive action that benefits the Magic Store community.",
      },
      {
        bannerUrl: 'stories/2/story_banner_url_3.jpg',
        title: 'Stay Updated with Magic Karma',
        description:
          "Magic Karma ensures you never miss an update. Every two minutes, your Karma score is refreshed, reflecting the activities you've completed. It's not just about patience; with Magic Karma, you can see your rewards come in almost instantly.",
      },
      {
        bannerUrl: 'stories/2/story_banner_url_4.jpg',
        title: 'Contribution that Counts',
        description:
          "Magic Karma is a dynamic scoring system designed to track your Magic Store activities. The more active you are, the higher your Karma score climbs, highlighting your contributions to the community. It's not just about using the Magic Store; it's about making positive actions and earning rewards in return.",
      },
      {
        bannerUrl: 'stories/2/story_banner_url_5.jpg',
        title: 'Convert Karma Points to USDT',
        description:
          'One of the key advantages of accumulating Magic Karma points is the ability to convert these points into USDT, a stablecoin tethered to the United States Dollar. It’s a simple and quick way to earn from your contributions to the Magic Store.',
      },
      {
        bannerUrl: 'stories/2/story_banner_url_6.jpg',
        title: 'Earn More with the Magic Karma Reward Program',
        description:
          'From accumulating Karma points to increasing your global Karma score, the Magic Karma Reward Program ensures that your positive actions are recognized and rewarded. Each contribution you make within the Magic Store platform brings you closer to exciting rewards.',
      },
    ],
  },
};
